import { com, kotlin } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import Patch from './Patch'
import { ConflictError } from './postEntities'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import serializeToJsonString = com.eidu.entity.util.serializeToJsonString
import PatchEntityRequest = com.eidu.entity.api.entities.PatchEntityRequest
import KtMap = kotlin.collections.KtMap
import EntityId = com.eidu.entity.EntityId
import FieldId = com.eidu.entity.field.FieldId

const toReferenceSetItemsKtMap = (items?: Map<FieldId, Map<EntityId, boolean>>) => {
  const byField = new Map<FieldId, KtMap<EntityId, boolean>>()
  for (const [fieldId, byItem] of items ?? []) byField.set(fieldId, KtMap.fromJsMap(byItem))
  return KtMap.fromJsMap(byField)
}

type PatchEntityParameters = {
  id: EntityId
  patch: Patch
}

const patchEntity = async ({ id, patch }: PatchEntityParameters) => {
  const response = await fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/entities/${id.toString()}`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(
        new PatchEntityRequest(
          patch.valuesToUpdateByFieldId ? KtMap.fromJsMap(patch.valuesToUpdateByFieldId) : KtMap.fromJsMap(new Map()),
          toReferenceSetItemsKtMap(patch.referenceSetItemsToUpdateByFieldId),
          patch.linksToUpdate ? KtMap.fromJsMap(patch.linksToUpdate) : KtMap.fromJsMap(new Map()),
          patch.externalValuesToUpdate ? KtMap.fromJsMap(patch.externalValuesToUpdate) : KtMap.fromJsMap(new Map())
        )
      ),
      method: 'PATCH',
    }
  )
  if (response.status === 409) {
    throw new ConflictError('Entity update conflict')
  } else if (response.status !== 200) {
    throw Error(`Unexpected response code ${response.status} from patchEntity endpoint`)
  }
}

export default patchEntity
